const { compose } = require('redux');
const { connect } = require('react-redux');
const { wrapHOC, wrapHOCComponent } = require('utils/framework');
const React = require('react');

const withRootComponentProps = compose(
    wrapHOC(connect(({ ssrProps }) => ({ ssrProps }))),
    wrapHOC((WrappedComponent, displayName) => {
        function RootComponentProps({ ssrProps, ...restProps }) {
            const props = ssrProps[displayName];

            return (
                <WrappedComponent
                    {...props}
                    {...restProps}
                />
            );
        }

        return wrapHOCComponent(RootComponentProps, 'RootComponentProps', [WrappedComponent, displayName]);
    })
);

module.exports = withRootComponentProps;
